/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-css";
import "prismjs/components/prism-markup";
import "prismjs/themes/prism-okaidia.css";

const SideSettings = () => {
  const { html, setHtml, css, setCss, activeView } = useContext(EditorContext);

  const editorStyles = {
    background: "#1d1e22",
    color: "#f92672",
    fontSize: 12,
    width: "100%",
    height: "calc(50vh - 86px)",
  };

  return (
    <div
      style={{
        display: activeView === "Full Page View" ? "none" : "flex",
      }}
      css={styles}
      className="sideSettings"
    >
      <div className="codeEditor">
        <div className="language">HTML</div>
        <Editor
          autoFocus={true}
          value={html}
          onValueChange={(html) => setHtml(html)}
          highlight={(html) => highlight(html, languages.html)}
          padding={10}
          style={editorStyles}
        />
      </div>
      <div className="codeEditor">
        <div className="language">CSS</div>
        <Editor
          value={css}
          onValueChange={(css) => setCss(css)}
          highlight={(css) => highlight(css, languages.css)}
          padding={10}
          style={editorStyles}
        />
      </div>
    </div>
  );
};

const styles = css`
  width: 100%;
  min-width: 500px;
  max-width: 500px;
  flex-direction: column;
  align-items: flex-start;
  height: calc(100vh - 88px);
  .codeEditor {
    width: 100%;
    .language {
      width: 100%;
      background: #1a1b1f;
      color: #aaaebc;
      display: flex;
      align-items: center;
      padding: 10px;
    }
  }
`;

export default SideSettings;
